import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { LoginPage } from '@betstarters/ui'
import { useAuth } from '@/hooks/use-auth'
import api from '@/api/client'

export function LoginPageWrapper() {
  const { t } = useTranslation()
  const { refreshUser } = useAuth()
  const navigate = useNavigate()

  return (
    <LoginPage
      subtitle={t('appSubtitle')}
      api={api}
      onSuccess={async () => {
        await refreshUser()
        navigate('/')
      }}
    />
  )
}
